<template>
	<div class="main">
		<ul id="leaveTypeNav" class="nav nav-tabs" role="tablist" style="width:100%;">
			<li class="text-center" data-leaveType="C" role="presentation">
				<a data-toggle="tab" @click="selectionleaveType('C')">退宿名單</a>
			</li>
			<li class="text-center" data-leaveType="L" role="presentation" v-if="isOpenLeaveByL">
				<a data-toggle="tab" @click="selectionleaveType('L')">離宿名單</a>
			</li>
      <li v-if="isAdmin('stay')">
        <router-link :to="{name:'stay.leave.note'}">離退宿備註設定</router-link>
      </li>
      <li v-if="isAdmin('stay')">
        <router-link :to="{name:'stay.leave.itemSetting'}">離退宿項目設定</router-link>
      </li>
		</ul>
		<section class="panel panel-default" style="margin-bottom: 0px;">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">住宿類別</label>
								<div class="col-md-8">
									<select v-model="dormitoryType" class="form-control" @change="smtr = ``">
										<option value="N">一般宿舍</option>
										<option value="V">寒暑假宿舍</option>
										<option value="S">特殊原因宿舍</option>
									</select>
								</div>
							</div>
							<div class="col-md-4" v-if="dormitoryType == 'N'">
								<label class="col-md-4">學期</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value" :selected="index == 0">{{year.text}}</option>
									</select>
								</div>
							</div>
							<div class="col-md-4" v-else>
								<label class="col-md-4">學年</label>
								<div class="col-md-8">
									<select v-model="smtr" class="form-control">
										<option value="">--請選擇--</option>
										<option v-for="(year, index) in selectYear()" :key="index" :value="year.value">{{year.text}}</option>
									</select>
								</div>
							</div>

							<div class="col-md-4">
								<label class="col-md-4">學號</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="account" />
								</div>
							</div>

						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12 ">
							<div class="col-md-4">
								<label class="col-md-4">宿舍</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="bedFloor" />
								</div>
							</div>
							<div class="col-md-4">
								<label class="col-md-4">寢室</label>
								<div class="col-md-8">
									<input type="text" class="form-control" v-model="bedRoom" />
								</div>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-offset-4 col-md-4 ">
							<div class="col-md-offset-4 col-md-4">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div id="leaveTypeContent" class="tab-content">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row form-group">
					<div class="col-md-12 text-right form-inline" v-if="isAdmin('stay')">
						<div class="col-md-6"></div>
						<div class="col-md-6">
              <button v-if="leaveType ==='L'" class="btn btn-danger hidden-xs" @click="gotoView('stay.leave.datePeriod',{})">設定離宿時段</button>
              <button v-if="leaveType ==='L'" class="btn btn-danger btn-block visible-xs" @click="gotoView('stay.leave.datePeriod',{})">設定離宿時段</button>
              <button class="btn btn-danger hidden-xs" @click="exportLeaveGuarantee">保證金粘存單</button>
              <button class="btn btn-danger btn-block visible-xs" @click="exportLeaveGuarantee">保證金粘存單</button>
              <button class="btn btn-danger hidden-xs" @click="exportCsv">名單清冊</button>
              <button class="btn btn-danger btn-block visible-xs" @click="exportCsv">名單清冊</button>
							<button class="btn btn-danger hidden-xs" @click="exportExcel">資料匯出</button>
							<button class="btn btn-danger btn-block visible-xs" @click="exportExcel">資料匯出</button>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<table class="table table-no-more table-bordered table-striped mb-none">
							<thead>
								<tr>
									<th class="text-center" style="width:9%">申請類別</th>
									<th class="text-center" width="6%">學期</th>
									<th class="text-center" width="10%">學制</th>
									<th class="text-center" width="15%">系科年班</th>
									<th class="text-center" width="8%">學生狀態</th>
									<th class="text-center" width="8%">學號</th>
									<th class="text-center" width="8%">姓名</th>
									<th class="text-center" width="8%">身分別</th>
									<th class="text-center" width="11%">離(退)宿日期</th>
									<th class="text-center" width="8%">點交狀態</th>
									<th class="text-center" width="11%">申請狀態</th>
									<th class="text-center" width="8%">
									</th>
								</tr>
							</thead>
							<tbody v-if="gridIsNotEmpty">
								<tr v-for="(item, index) in roomLeaveList.rows" :key="index">
									<td class="text-center" data-title="申請類別">{{getDormitoryTypeStr(item.dormitoryType)}}</td>
									<td class="text-center" data-title="學期">{{item.smtr}}</td>
									<td class="text-center" data-title="學制">{{item.deptSsymStr}}</td>
									<td class="text-center" data-title="系科年班">{{item.deptCodeStr}}<br/>{{item.drade}}年{{item.dradeClass}}班</td>
									<td class="text-center" data-title="學生狀態">{{item.stateStr}}</td>
									<td class="text-center" data-title="學號">{{item.account}}</td>
									<td class="text-center" data-title="姓名">
										<a class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" @click="gotoView('stay.leave.apply', {leaveType: item.leaveType, account: item.account, idno: item.idno, id:item.id})">{{item.name}}</a>
									</td>
									<td class="text-center" data-title="身分別">{{item.stuIdentityStr}}</td>
									<td class="text-center" data-title="離(退)宿日期">{{customFormatter(item.leaveDate)}}</td>
									<td class="text-center" data-title="點交狀態">{{item.leaveAcceptStr}}</td>
									<td class="text-center" data-title="申請狀態">{{item.leaveStatusStr}}</td>
									<td class="text-center" data-title="">
										<button type="button" v-if="item.leaveType == 'C'" @click="openReport(item)" class="btn btn-link" style="margin: 0 !important;padding: 0 !important;" >列印</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center">
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<reoprtPopup v-if="isOpenPopup" :idno="popupParam.idno" :account="popupParam.account" :applyId="popupParam.id"/>
	</div>
</template>

<script>
import reoprtPopup from './report.vue';
export default {
	components:{
		reoprtPopup
	},
	data() {
		return {
			page: 1,
			totalPage: 1,
			accountType: "",
			isDefault: true,
			isOpenLeaveByL:true,
			leaveType: "",
			roomLeaveList:{},
			isOpenPopup:false,
			dormitoryType:"N",
			smtr:"",
			account:"",
			bedFloor:"",
			bedRoom:"",
			popupParam:{
				idno:"",
				account:"",
				id:"",
			}
		}
	},
	mounted() {
		let _this = this;
		if (this.sessionData == null) {
			this.$router.replace({ path: '/' });
		}else{
			if(this.sessionData.accountType == "STU"){
				this.itemIsOpening().then(()=>{
					this.navInitEvent();
				});
			}else{
        //套用查詢設定
        const storeQryParam = JSON.parse(this.getStore(`${this.$route.name}.qryParam`));
        if(storeQryParam != null) {
          this.leaveType = storeQryParam.leaveType;
          this.dormitoryType = storeQryParam.dormitoryType;
          this.smtr = storeQryParam.smtr;
          this.account = storeQryParam.account;
          this.bedFloor = storeQryParam.bedFloor;
          this.bedRoom = storeQryParam.bedRoom;
        }

        const storePage = this.getStore(`${this.$route.name}.page`);
        if(storePage != null) {
          this.page = storePage;
        }

				this.navInitEvent();
			}
		}
	},

	methods: {
		selectionleaveType(leaveType) {
			if (leaveType != this.leaveType) {
				this.page = 1;
				this.dormitoryType = "N";
				this.smtr = "";
				this.account = "";
				this.bedFloor = "";
				this.bedRoom = "";
			}
			this.leaveType = leaveType;
			let qryParam = {
				leaveType: leaveType,
				dormitoryType:this.dormitoryType,
				smtr:this.smtr,
				account:this.account,
				bedFloor:this.bedFloor,
				bedRoom:this.bedRoom,
			};
			if(this.sessionData.accountType == "STU"){
				let key = this.sessionData.isRoomMage == "Y" ? "mageAccount":"account"
				qryParam[key] = this.sessionData.account;
			}
			const api = "/api/Room/roomLeaveGrid";
			this.$axios.post(api, JSON.stringify({
				model:qryParam,
				page:this.page,
				pageSize : 10,
			})).then(resp => {
        this.roomLeaveList = resp.data.data;
        this.totalPage = this.roomLeaveList.total;
        this.page = this.roomLeaveList.page;
			});
		},
		updateGrid(page) {
			this.page = page;
			this.selectionleaveType(this.leaveType);
		},
		navInitEvent(){
      if(this.leaveType == "" || this.leaveType == "C") {
        this.leaveType = "C";
        document.querySelector("[id='leaveTypeNav']").children[0].classList.add("active");
      }
       else if(this.leaveType == "L") {
        document.querySelector("[id='leaveTypeNav']").children[1].classList.add("active");
      }
			this.selectionleaveType(this.leaveType);
		},
		applyChange(item) {
			const api = "/api/RoomLeave/applyChange";
			let tmpList = [];
			tmpList.push(item);
			this.$axios.post(api, tmpList).then(resp => {
				if (resp.data.status != "success") {
					bootbox.alert(resp.data.msg);
				}
			});
		},
		openReport(item){
			this.popupParam = {
				idno:item.idno,
				account:item.account,
				id:item.id
			};
			this.showPopupControl(true);
		},
		showPopupControl(isOpen){
			this.isOpenPopup = isOpen;
		},
		async itemIsOpening(){
			const apiSetting = "/api/Common/roomTimeSettingByType/";
			let resp = await this.$axios.post(apiSetting);
			for(let i=0; i<resp.data.data.length; i++){
				if(resp.data.data[i].key === "L"){
					this.isOpenLeaveByL = resp.data.data[i].value == "Y";
				}
			}
		},
		exportExcel() {
			const api = "/api/Room/exportLeaveData/"+this.leaveType;
			this.$axios.post( api, JSON.stringify({

			}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "離宿資料_"+this.customFormatter(new Date())+".xlsx");
				document.body.appendChild(link);
				link.click();
			});
		},
    exportCsv() {
      if(this.smtr == "") {
        bootbox.alert("請在查詢條件設定「學期」後才能執行此操作");
      }
      else {
        const api = `/api/Room/exportLeaveDataCsv/${this.leaveType}/${this.smtr}`;
        this.$axios.post( api, JSON.stringify({

        }), {
          headers: { "Content-Type": "application/json" },
          responseType: "blob"
        }).then(resp => {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${this.smtr}學期宿舍保證金退費清冊.csv`);
          document.body.appendChild(link);
          link.click();
        });
      }
    },
    exportLeaveGuarantee() {
      if(this.smtr == "") {
        bootbox.alert("請在查詢條件設定「學期」後才能執行此操作");
      }
      else {
        const api = `/api/Room/exportLeaveGuarantee/${this.leaveType}/${this.smtr}`;
        this.$axios.post( api, JSON.stringify({
        }), {
          headers: { "Content-Type": "application/json" },
          responseType: "blob"
        }).then(resp => {
          const url = window.URL.createObjectURL(new Blob([resp.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${this.smtr}宿舍保證金退費報支粘存單.docx`);
          document.body.appendChild(link);
          link.click();
        });
      }
    },
		getDormitoryTypeStr(dormitoryType){
			let str = "";
			if(dormitoryType == "N"){
				str = "一般宿舍";
			}else if(dormitoryType == "S"){
				str = "特殊宿舍";
			}else if(dormitoryType == "V"){
				str = "寒暑假宿舍";
			}
			return str;
		},
		selectYear(){
			let smtrArray = [];
			let nowYear = (new Date().getFullYear() - 1911);
			let nowMonth = new Date().getMonth() + 1;
			if(nowMonth < 8){
				nowYear = nowYear-1;
			}
			for(let y = nowYear; y > 107 ; y--){
				if(this.dormitoryType == "N"){
					smtrArray.push({text:y+"年第二學期",value:y+"2"});
					smtrArray.push({text:y+"年第一學期",value:y+"1"});
				}else{
					smtrArray.push({text:y+"年",value:`${y}`});
				}
			}
			return smtrArray;
		},
	},
	computed:{
		gridIsNotEmpty(){
			return !this.jsonIsEmpty(this.roomLeaveList);
		}
	},
  beforeRouteLeave(to, from, next) {
    //保留查詢設定
    if(to.name === "stay.leave.apply") {
      this.setStore(`${this.$route.name}.qryParam`, {
        leaveType: this.leaveType,
        dormitoryType:this.dormitoryType,
        smtr:this.smtr,
        account:this.account,
        bedFloor:this.bedFloor,
        bedRoom:this.bedRoom,
      });
      this.setStore(`${this.$route.name}.page`, this.page);
    } else {
      this.removeStore(`${this.$route.name}.page`);
      this.removeStore(`${this.$route.name}.qryParam`);
    }
    this.removeStore(this.$route.name);
    next();
  }
}
</script>

<style scoped>
</style>
